'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

GroupsConfig=class GroupsConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('groups',{
url:'/groups?groupId',
reloadOnSearch:!1});

$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=GroupsConfig;
//# sourceMappingURL=groupsConfig.js.map
